
import { Component } from 'vue-property-decorator';
import ElementBase from './ElementBase';
import { ClassMap, StyleMap } from '../configuration/ElementConfiguration';
import { ActivityAssignment } from '../../backend/backendapi';
import ActivityAssignmentListConfiguration from '../configuration/ActivityAssignmentListConfiguration';
import { evaluate } from "../expression";

@Component({
  name: 'ActivityAssigmentList',
  components: {},
})
export default class ActivityAssigmentList extends ElementBase {
  private assignments: ActivityAssignment[] | null = null;

  private get activityAssignmentListConfiguration(): ActivityAssignmentListConfiguration {
    return this.configuration as ActivityAssignmentListConfiguration;
  }

  private get tableClass(): ClassMap {
    const classes = this.activityAssignmentListConfiguration.tableClass ?? {};
    return evaluate(classes, this.bindingsContext);
  }

  private get tableStyle(): StyleMap {
    const style = this.activityAssignmentListConfiguration.tableStyle ?? {};
    return evaluate(style, this.bindingsContext);
  }

  private get groupedAssignments(): Map<string, ActivityAssignment[]> {
    const ret = new Map<string, ActivityAssignment[]>();
    for (let assignment of (this.assignments ?? [])) {
      const assignee = this.formatAssignee(assignment);
      let l = ret.get(assignee);
      if (l === undefined) {
        ret.set(assignee, l = []);
      }
      l.push(assignment);
    }
    return ret;
  }

  constructor() {
    super();
    this.lastDataUpdate = new Date(0);
    this.timeoutSeconds = 120;
  }

  async mounted(): Promise<void> {
    await super.mounted();
    this.enableTimeout();
  }

  public onInformationPush(elementPath: string, json: string): void {
    super.onInformationPush(elementPath, json);

    if (elementPath !== this.elementPath) {
      return;
    }

    const update = JSON.parse(json);
    Object.entries(update).forEach(([key, value]) => {
      if (key === 'activityAssignmentList') {
        this.assignments = value as ActivityAssignment[];
        this.lastDataUpdate = new Date();
      }
    });
  }

  protected defaultStyle(): StyleMap {
    return Object.assign({}, super.defaultStyle(), { 'overflow-x': 'hidden', 'overflow-y': 'auto' });
  }

  private formatAssignee(assignment: ActivityAssignment): string {
    const format = evaluate(this.activityAssignmentListConfiguration.assigneeFormat, this.bindingsContext) ?? '{{email}}';
    return format.replace(/\{\{email}}/, assignment.email ?? '')
        .replace(/\{\{lastname}}/, assignment.lastName ?? '')
        .replace(/\{\{lastname.1}}/, (assignment.lastName ?? '').substring(0, 1))
        .replace(/\{\{firstname}}/, assignment.firstName ?? '')
        .replace(/\{\{firstname.1}}/, (assignment.firstName ?? '').substring(0, 1));
  }

  formatAssignment(assignment: ActivityAssignment): string {
    const format = evaluate(this.activityAssignmentListConfiguration.assignmentFormat, this.bindingsContext) ?? '{{activity}}';
    return format.replace(/\{\{activity}}/, assignment.activity ?? '')
        .replace(/\{\{duty}}/, assignment.duty ?? '')
        .replace(/\{\{cell}}/, assignment.cell ?? '');
  }
}
